import { render, staticRenderFns } from "./ReportPanel.vue?vue&type=template&id=506bed2a&scoped=true"
import script from "./ReportPanel.vue?vue&type=script&lang=js"
export * from "./ReportPanel.vue?vue&type=script&lang=js"
import style0 from "./ReportPanel.vue?vue&type=style&index=0&id=506bed2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bed2a",
  null
  
)

export default component.exports